import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { ClienteCentralCompraParticipanteModule } from './participante';

import { ClienteCentralCompraComponent } from './cliente-central-compra.component';

@NgModule({
    imports: [
        SharedModule,
        ClienteCentralCompraParticipanteModule
    ],
    declarations: [
        ClienteCentralCompraComponent
    ],
    exports: [
        ClienteCentralCompraComponent
    ]
})
export class ClienteCentralCompraModule { }
